import { EasyContainer } from '../baseClasses/easyContainer';
import { FieldOptions, EasyForm, EasyCardField, EasyTabField, EasyAccordionField, IEasyContainerGroup } from '../index';

export class EasyExpansionPanelField extends EasyContainer implements IEasyContainerGroup {
    controlType = 'expansion-panel';

    constructor(header: string, options: FieldOptions<any> = {}, form: EasyForm) {
        super(header, options, form, 'expansion-panel');
    }

    addCardContainer(header: string, options: FieldOptions<any> = {}): EasyCardField {
        let container = new EasyCardField(header, options, this.form)

        this.addContainer(container);

        return container;
    }

    addTabContainer(header: string, options: FieldOptions<any> = {}): EasyTabField {
        let tabs = new EasyTabField(this.form, options);
        this.addContainer(tabs);

        return tabs;
    }

    addAccordionContainer(header: string, options: FieldOptions<any> = {}): EasyAccordionField {
        let accordion = new EasyAccordionField(this.form, options);
        this.addContainer(accordion);

        return accordion;
    }

    addExpansionPanelContainer(header: string, options: FieldOptions<any> = {}): EasyExpansionPanelField {
        let container = new EasyExpansionPanelField(header, options, this.form);
        this.addContainer(container);

        return container;
    }
}
